// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  dashboard: `Dashboard`,
  auth: {
    logout: 'Logout',
    tech_support: 'Tech Support',
  },
  banners: {
    practicum: {
      title: 'Practicum',
      description: 'Training materials and practical assignments for effective work.',
      button: 'Go to',
    },
    news: {
      title: 'News',
      description: 'Latest updates, news, and important announcements.',
      button: 'Read',
    },
  },
  companies: {
    name_company: `Shop Name`,
    edit_shop: `Edit Shop`,
    shops_list: 'Shops List',
    add_shop: `Add Shop`,
    set_manager: `Set Manager`,
    time_working: `Working Time`,
    token_tg: `Telegram Token`,
    your_companies: `Your Shops`,
  },
  employees: {
    calculate_wage: `Calculate Wage`,
    self: `Employees`,
  },
  games: {
    leaderboard: {
      balance: `Balance`,
      referral: `Referral`,
    },
  },
  qs: {
    One_company: `One Company`,
    One_service: `One Service`,
    One_staff: `One Staff`,
    at_least: `At least`,
    first_add: `First Add`,
    name_desc_adr: `Name, Description, Address`,
    name_price_duration: `Name, Price, Duration`,
    namestaff_specialization: `Name, Staff, Specialization`,
    open_recording_set_time: `Open Recording, Set Time`,
    set_staff_schedule: `Set Staff Schedule`,
    staff_service: `Staff Service`,
    to_staff: `To Staff`,
  },
  services: {
    self: `Services`,
  },
  system: {
    add: `Add`,
    address: `Address`,
    allowed: `Allowed`,
    are_you_sure_want_to_delete: `Are you sure you want to delete?`,
    contacts: `Contacts`,
    copied: `Copied`,
    create: `Create`,
    delete: `Delete`,
    description: `Description`,
    edit: `Edit`,
    max_size_of: `Max size of`,
    partners: `Partners`,
    save_changes: `Save Changes`,
    selected: `Selected`,
    view_all: `View All`,
  },
};

export default en;
